import './HiddenIframe.scss';

import { useEffect, useRef } from 'react';

import { useMessage } from '@/lib/hooks';
import { log } from '@/lib/log';

type HiddenIframeProps = {
  type: string;
  actionUrl?: string;
  value?: string;
};

const HiddenIframe = (props: HiddenIframeProps) => {
  const allowedOrigin = import.meta.env.VITE_APP_ENVIRONMENT === 'production' ? 'https://payments.mppglobal.com' : 'https://paymentsuat.mppglobal.com';

  let identifier;
  let fieldName;

  switch (String(props.type).toLowerCase()) {
    case 'hidden':
      identifier = 'threeDSecureHidden';
      fieldName = 'threeDSMethodData';
      break;

    case 'challengev1':
    case 'challengev2':
      identifier = 'threeDSChallenge';
      fieldName = 'creq';
      break;

    default:
      throw Error(`Unsupported iFrame type "${props.type}"`);
  }

  useMessage(messageHandler);

  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    let mounted = true;
    const body = document.querySelector('body');
    body?.classList.add('overflow-hidden');

    if (mounted && props.actionUrl && formRef.current) {
      log(`Submitting form to ${props.actionUrl}`, formRef);

      formRef.current.submit();
    }

    return () => {
      body?.classList.remove('overflow-hidden');
      mounted = false;
    };
  }, [ props.actionUrl, props.value ]);

  /**
   * Message handler for iframe communication
   * @param {MessageEvent} e - The message event from the iframe
   */
  function messageHandler(e: MessageEvent) {
    log(`HiddenIframe: Receiving message from hidden iframe ${e.origin}`, e.data);

    if (e.origin === allowedOrigin) {
      log('Removing event listener for hidden iframe');
      window.removeEventListener('message', messageHandler);
    }
  }

  return (
    <>
      <iframe
        className={import.meta.env.NODE_ENV}
        id={`${identifier}Frame`}
        name={`${identifier}Frame`}
        title={`${identifier} iFrame`}
      ></iframe>
      <form
        action={decodeURIComponent(props.actionUrl ?? '')}
        id={`${identifier}Form`}
        method="post"
        name={`${identifier}Form`}
        ref={formRef}
        target={`${identifier}Frame`}
      >
        {props.value ? (
          <input
            name={fieldName}
            type="hidden"
            value={props.value}
          />
        ) : null}
      </form>
    </>
  );
};

export { HiddenIframe };
